export default "__VITE_ASSET__CeDwKyqm__"